




































import { SharedState } from "@/common/state";
import { computed, onBeforeUnmount, onMounted } from "@vue/composition-api";
import Vue from "vue";
import DashboardItem from "../../../../common/DashboardItem.vue";
import { state } from "./state";
import Sensitivities2 from "@/components/filters-bar/Sensitivities2.vue";
import { POPULATION_TYPE } from "@/common/models";
export default Vue.extend({
  components: {
    DashboardItem,

    Sensitivities2,
  },
  props: ["as_modal"],
  setup(props) {
    const {
      results,
      init,
      is_loading,
      on_item_clicked,
      selected_sensitivity,
      toggle_sensitivity,
      info_dirs,
      selected_info_dir,
      set_selected_info_dir,
    } = state;
    const frame_date = computed(
      () => SharedState.selectedTimeFrameDisplayName.value
    );

    onMounted(() => {
      SharedState.onReady(async () => {
        await init();
      });
    });

    onBeforeUnmount(() => state.destroy());

    const org_has_more_than_one_source = computed(
      () => SharedState.data_sources.value.length > 1
    );

    const display_items = computed(() => {
      if (props.as_modal) {
        return results.value.filter((f) => f.type !== POPULATION_TYPE.FOLDER);
      } else {
        return results.value;
      }
    });

    return {
      frame_date,
      is_loading,
      display_items,
      on_item_clicked,
      selected_sensitivity,
      toggle_sensitivity,
      info_dirs,
      selected_info_dir,
      set_selected_info_dir,
      org_has_more_than_one_source,
    };
  },
});
